export default __webpack_public_path__ + "static/media/010_home.hevc.55e34437.mp4";